import {
    HOST,
    RECOMM_PROFILE_REQUEST,
    RECOMM_PROFILE_FAIL,
    RECOMM_PROFILE_SUCCESS
} from '../../types'

import i18n from "i18next"

export const getProfileRecommendations = (token) => {
    return dispatch => {
        try {
            dispatch({
                type: RECOMM_PROFILE_REQUEST,
            })
            return fetch(`${HOST}/v1/customer/my-selections`, {
                method: "GET",
                headers: {
                    'Authorization': 'Bearer ' + token, 
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
                .then(response => response.json())
                .then(data => {
                    if (!data.data) {
                        throw new Error(data.message)
                    }
                    dispatch({
                        type: RECOMM_PROFILE_SUCCESS,
                        payload: data.data
                    })
                    return data.data;
                })
                .catch(error => {
                    const message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    dispatch({
                        type: RECOMM_PROFILE_FAIL,
                        payload: message
                    })
                })
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: RECOMM_PROFILE_FAIL,
                payload: message
            })
            return Promise.reject();
        }
    }
}